import { MODAL_AUTH } from '@components/App/Modal/constants'
import { Input } from '@lib/components'
import { IconLeft } from '@lib/icons'
import { PasswordResetSuccess } from '@lib/images'
import { Button } from '@octopus-do/octopus-storybook'
import { closeModal, openModal } from '@storeOld/reducers/ui'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import API from '@/api'
import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { getId } from '@/utils/temporaryHelper'

const LOADING_ANIMATION = 1000

const MODE_LOADING = 'MODE_LOADING'
const MODE_DEFAULT = 'MODE_DEFAULT'
const MODE_SUCCESS = 'MODE_SUCCESS'

const ForgotPassword = (props) => {
  const [mode, setMode] = useState(MODE_DEFAULT)
  const [emailError, setEmailError] = useState(null)
  const [isRequested, setIsRequested] = useState(false)

  useEffect(() => {
    if (mode === MODE_SUCCESS) {
      window.localStorage.setItem('reset-password-id', getId())
    }
  }, [mode])

  const validate = (val) => {
    if (!val) {
      return 'Please enter your email'
    }

    if (!/^[^@]+@[^@]+\.[^@]+$/.test(val)) {
      return 'Please enter a valid email'
    }

    return true
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (mode === MODE_LOADING) {
      return
    }

    sendGtmEvent(GtmTriggerName.AUTH_RESET_PASS, 'Click to reset password')
    setIsRequested(true)

    const { elements } = e.target

    setEmailError(null)

    if (typeof validate(elements.emailAddress.value) === 'string') {
      return setEmailError(validate(elements.emailAddress.value))
    }

    setMode(MODE_LOADING)

    try {
      const t1 = Date.now()

      await API.Auth.reset({ emailAddress: elements.emailAddress.value })

      const t = Date.now() - t1

      if (t >= LOADING_ANIMATION) {
        setMode(MODE_SUCCESS)
      } else {
        setTimeout(() => {
          setMode(MODE_SUCCESS)
        }, LOADING_ANIMATION - t)
      }
    } catch (e) {
      setMode(MODE_SUCCESS)
    }
  }

  const dispatch = useDispatch()

  const onBack = () => {
    dispatch(closeModal())
    dispatch(openModal(MODAL_AUTH))
  }

  if (mode === MODE_SUCCESS) {
    return (
      <div className="Reset__content">
        <div className="Register">
          <div className="Register__content-body">
            <div className="Register__close">{props.closeButton}</div>
            <PasswordResetSuccess />

            <div className="Register__heading">
              <h3>Check your inbox</h3>

              <p>
                If the submitted email corresponds to a registered account, we
                have sent an email to reset your password. You may close this
                window.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="Register">
      <div className="Register__content-body">
        <div className="Register__back" onClick={onBack}>
          <IconLeft />
          <span>Back</span>
        </div>
        <div className="Register__close">{props.closeButton}</div>

        <div className="Register__heading">
          <h3>Password reset</h3>

          <p>
            Please enter your email to receive instructions on how to reset your
            password.
          </p>
        </div>

        <form className="Modal-link" onSubmit={handleSubmit}>
          <Input
            name="emailAddress"
            placeholder="Enter your email"
            disabled={mode === MODE_LOADING}
            onChange={(value) => {
              if (isRequested) {
                if (typeof validate(value) === 'string') {
                  return setEmailError(validate(value))
                }

                return setEmailError(null)
              }
            }}
          />

          {emailError && <div className="Register__error">{emailError}</div>}

          <div className="Register__commit">
            <Button
              type="submit"
              label="Reset Password"
              loading={mode === MODE_LOADING}
            />
          </div>
        </form>
      </div>
    </div>
  )
}

export default ForgotPassword
